import { useEffect } from 'react';
import Select, { StylesConfig, CSSObjectWithLabel } from 'react-select';

interface DebitNoteItem {
  credit_note_status_id: number;
  credit_note_status_name: string;
  label?: string;
  value?: number;
  [key: string]: any;
}

interface DebitNoteOptionsProps {
  bulkActionData: any[];
  onFilterSelect: (val: any | null) => void;
  defaultVal?: DebitNoteItem | null;
}

const customStyles: StylesConfig<DebitNoteItem, false> = {
  control: (provided, state) =>
    ({
      ...provided,
      height: 45,
      backgroundColor: '#fff',
      width: 200,
    } as CSSObjectWithLabel),
  indicatorSeparator: (provided, state) =>
    ({
      ...provided,
      display: 'none',
    } as CSSObjectWithLabel),
  valueContainer: (provided, state) =>
    ({
      ...provided,
      height: 20,
      paddingBottom: '45px',
      marginLeft: '13px',
    } as CSSObjectWithLabel),
  option: (provided, state) =>
    ({
      ...provided,
      backgroundColor: state.isSelected ? '#f1f1f1' : '#fff',
      color: 'black',
    } as CSSObjectWithLabel),
};

const DebitNoteOptions: React.FC<DebitNoteOptionsProps> = ({ bulkActionData, onFilterSelect, defaultVal }) => {
  useEffect(() => {}, [bulkActionData]);


  const customOption = bulkActionData
    ?.filter(item => item.debit_note_status_id !== 0)
    .map(item => ({
      ...item,
      label: item.debit_note_status_name,
      value: item.debit_note_status_id,
    }));

  return (
    <Select
      styles={customStyles}
      onChange={val => onFilterSelect(val as DebitNoteItem | null)}
      defaultValue={defaultVal}
      placeholder="Change Status"
      options={customOption}
    />
  );
};

export default DebitNoteOptions;
